import { render, staticRenderFns } from "./RqtaEditAppr.vue?vue&type=template&id=7f5c66aa&scoped=true&"
import script from "./RqtaEditAppr.vue?vue&type=script&lang=js&"
export * from "./RqtaEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5c66aa",
  null
  
)

export default component.exports